import { 
    SENSORS_CONNECT,
    SENSORS_DISCONNECT,
    SENSORS_ERROR,
    SENSORS_UPDATE
} from "../../constants/action-types";

export function sensorsConnect(data){
    return { type: SENSORS_CONNECT, payload: data } }

export function sensorsDisconnect(data){
    return { type: SENSORS_DISCONNECT, payload: data } }

export function sensorsError(data){
    return { type: SENSORS_ERROR, payload: data } }

export function sensorsUpdate(data){
    return { type: SENSORS_UPDATE, payload: data } }



// WEBPACK FOOTER //
// ./src/store/actions/sensors.js